import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, Teleport as _Teleport } from "vue"
import _imports_0 from './images/dialog-close.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, " 자, 원더플 피플이라면누구나 맞출 수 있는 퀴즈! "),
  /*#__PURE__*/_createElementVNode("div", null, " 먼저 확인해볼까요? "),
  /*#__PURE__*/_createElementVNode("div", { class: "color-primary tip" }, " (* 끝까지 완료해주셔야 신청 접수가 이뤄집니다.) ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "당첨자로 선정되실 경우"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("모든 연락/배송지는 "),
    /*#__PURE__*/_createElementVNode("span", { class: "color-primary" }, "신청하신 대표자"),
    /*#__PURE__*/_createTextVNode(" 분의 정보로 전달됩니다.")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", null, "원더플 피플, 환영합니다!"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("div", null, "캠페인 참여자로 선정되시면 아래의 주소로"),
    /*#__PURE__*/_createElementVNode("div", null, "제로 웨이스트 박스가 발송됩니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("div", null, "수령지 주소 변경을 원하시면"),
    /*#__PURE__*/_createElementVNode("div", null, "아래의 신청 내역 확인 / 주소지 변경하기"),
    /*#__PURE__*/_createElementVNode("div", null, "버튼을 클릭해주세요.")
  ])
], -1)
const _hoisted_6 = { class: "dialog-content participate-content" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("단체 참여자에게는 ")
const _hoisted_8 = { class: "color-primary" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("가 발송돼요!")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "참여하는 단체명을 정확히 써주세요.", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("개인 참여자에게는 ")
const _hoisted_13 = { class: "color-primary" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("가 발송돼요!")
const _hoisted_15 = {
  key: 2,
  class: "people-collection-type"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "혼자서도 잘해요!", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "big" }, " 개인 ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "함께 하고 싶어요!", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "big" }, " 단체(3~4인 이상) ", -1)
const _hoisted_20 = { class: "dialog-content quiz-content" }

import { reactive, ref, inject, computed } from 'vue';
  import { IProgram } from '@/types/program';
  import { ISurveySection, ISurveyQuestion, ISurveryOption, ISurvey } from '@/types/survey';
  import dayjs from 'dayjs';
  import _ from 'lodash';
  import { ColorVariants, PEOPLE_COLLECTION } from '@/constants';
  import { request, kakaoShare } from '@/utils';
  import { useRouter } from 'vue-router';

  interface IProps {
    program: IProgram;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    program: IProgram;
  }

  
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
  const router = useRouter();
  const dialog = reactive({
    ready: false,
    oneMoreTime: false,
    cancelParticipate: false,
    completed: false,
    participate: false,
    quiz: false,
    quizAnswerConfirm: false,
    quizeCancel: false,
  });
  const peopleCollection = ref<string | undefined>();
  const groupName = ref<string | undefined>();
  const question = ref<ISurveyQuestion>();
  const quizInput = ref<string>('');
  const OPTION_NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  let questions: ISurveyQuestion[] = [];
  let questionForm: {
    survey_id: number;
    type: 'CampaignResponse';
    program_id: number;
    started_at: string;
    completed_at: string;
    answers_attributes: {
      value?: string; // 简答题传
      value_type?: 'text'; // 简答题传
      survey_question_id: number;
      survey_option_ids?: number[] // 选择题传
    }[]
  };

  const participateDialogTitle = computed(() => {
    if (peopleCollection.value) {
      return peopleCollection.value === PEOPLE_COLLECTION.individual ? '혼자서도 원더플 피플!' : '함께하는 원더플 피플!';
    }
    return '원더플 시즌3 어떻게 참여 하실건가요?';
  });

  const participateDialogButtons = computed(() => {
    if (peopleCollection.value) {
      if (peopleCollection.value === PEOPLE_COLLECTION.group) {
        return [
          { text: '닫기', style: ColorVariants.dark, click: () => handleCancelParticipate() },
          { text: '신청하기', disabled: !groupName.value, style: ColorVariants.primary, click: () => showDialog('oneMoreTime') },
        ];
      } else {
        return [
          { text: '닫기', style: ColorVariants.dark, click: () => handleCancelParticipate() },
          { text: '신청하기', style: ColorVariants.primary, click: () => participate() },
        ];
      }
    }
    return [];
  });

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
  }

  function handleNavToRecordDetail() {
    closeDialog();
    router.push({ name: 'mine.programParticipationDetail', params: { id: props.program.participation_request_id } });
  };

  function handleKakaoShare() {
    return kakaoShare({
      title: props.program.share_setting?.share_title || props.program.name,
      imageUrl: props.program.share_setting?.share_image?.url || props.program.image?.url,
    });
  }

  async function nextQuestion() {
    if (questions.length > questionForm.answers_attributes.length) {
      question.value = questions[questionForm.answers_attributes.length];
      showDialog('quiz');
    } else {
      // 没有下一题了
      questionForm.completed_at = dayjs().toISOString();
      await request.post('responses', questionForm);
      await refreshPageData();
      showDialog('participate');
    }
  }

  function handleAnswerQuiz(option?: ISurveryOption) {
    if (option) {
      if (option.is_correct) {
        questionForm.answers_attributes.push({
          survey_question_id: (question.value as ISurveyQuestion).id as number,
          survey_option_ids: [option.id as number]
        });
        return nextQuestion();
      }
    }
    if (quizInput.value) {
      questionForm.answers_attributes.push({
        survey_question_id: (question.value as ISurveyQuestion).id as number,
        value: quizInput.value,
        value_type: 'text'
      });
      // 清空input
      quizInput.value = '';
      return nextQuestion();
    }
    // 答案不正确
    showDialog('quizAnswerConfirm');
  }

  function handleCancelQuiz() {
    showDialog('quizeCancel');
  }

  async function participate() {
    await request.post(`programs/${props.program.id}/participate`, {
      // 默认值individual
      people_collection: peopleCollection.value || PEOPLE_COLLECTION.individual,
      group_name: groupName.value,
    });
    await refreshPageData();
    showDialog('completed');
  }

  function startQuiz (quiz: ISurvey) {
    const surveySections: ISurveySection[] = _.get(quiz, 'survey_sections') || [];
    questions = _.flatMap(surveySections.map(item => item.survey_questions));
    questionForm = {
      survey_id: quiz.id as number,
      type: 'CampaignResponse',
      program_id: props.program.id,
      started_at: dayjs().toISOString(),
      completed_at: '',
      answers_attributes: []
    };
    showDialog('ready');
  };

  function startParticipate() {
    // 清空步骤
    peopleCollection.value = undefined;
    groupName.value = undefined;
    showDialog('participate');
  };

  function handleSelectPeopleCollection(val: PEOPLE_COLLECTION) {
    peopleCollection.value = val;
  }

  function handleCancelParticipate() {
    showDialog('cancelParticipate');
  }

  const start = () => {
    const quiz = props.program?.campaign_quiz as ISurvey;
    if (quiz) {
      startQuiz(quiz);
    } else {
      startParticipate();
    }
  };

  expose({
    start
  });


return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).ready,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).ready) = $event)),
      class: "dialog-coca-cola",
      title: "원더플 지구를 위한 첫 걸음을 시작하셨네요!",
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '시작하기', style: _unref(ColorVariants).primary, click: () => nextQuestion() }
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).cancelParticipate,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).cancelParticipate) = $event)),
      class: "dialog-coca-cola",
      title: "정말 신청을 취소하시겠습니까?",
      content: "닫기 버튼을 클릭하면 캠페인 신청이 취소됩니다.",
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '돌아가기', style: _unref(ColorVariants).primary, click: () => startParticipate() },

      ]
    }, null, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).oneMoreTime,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).oneMoreTime) = $event)),
      class: "dialog-coca-cola",
      title: "한 번 더 !",
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '신청하기', style: _unref(ColorVariants).primary, click: () => participate() }
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).completed,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(dialog).completed) = $event)),
      title: "캠페인 모집 신청 완료",
      class: "dialog-coca-cola dialog-coca-cola-completed",
      btns: [
        { text: '신청 내역 확인 & 주소 변경하기', style: _unref(ColorVariants).primary, click: () => handleNavToRecordDetail() },
        { text: '카카오톡 친구에게 공유하기', style: _unref(ColorVariants).secondary, click: () => handleKakaoShare() },
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "dialog-close-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (closeDialog()))
        }, _hoisted_4),
        _hoisted_5
      ]),
      _: 1
    }, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).quizAnswerConfirm,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_unref(dialog).quizAnswerConfirm) = $event)),
      class: "dialog-coca-cola",
      title: "정말일까요?",
      content: "  ",
      btns: [
        { text: '다시 풀기', style: _unref(ColorVariants).primary, click: () => showDialog('quiz') }
      ]
    }, null, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).quizeCancel,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_unref(dialog).quizeCancel) = $event)),
      class: "dialog-coca-cola",
      title: "정말 신청을 취소하시겠습니까?",
      content: "닫기 버튼을 클릭하면 캠페인 신청이 취소됩니다.",
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '돌아가기', style: _unref(ColorVariants).primary, click: () => showDialog('quiz') },
      ]
    }, null, 8, ["visible", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).participate,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_unref(dialog).participate) = $event)),
      btns: _unref(participateDialogButtons),
      title: _unref(participateDialogTitle),
      class: "dialog-coca-cola"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (peopleCollection.value === _unref(PEOPLE_COLLECTION).group)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(__props.program.max_number_of_user_group_type_collections) + "개의 제로 웨이스트 박스", 1),
                  _hoisted_9
                ]),
                _hoisted_10,
                _createVNode(_component_b_form_input, {
                  modelValue: groupName.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((groupName).value = $event)),
                  class: "input",
                  required: "",
                  type: "text",
                  placeholder: "참여 단체명"
                }, null, 8, ["modelValue"])
              ], 64))
            : (peopleCollection.value === _unref(PEOPLE_COLLECTION).individual)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(__props.program.max_number_of_user_individual_type_collections) + "개의 제로 웨이스트 박스", 1),
                  _hoisted_14
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_AppLoadingButton, {
                    class: "btn",
                    variant: _unref(ColorVariants).primary,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (handleSelectPeopleCollection(_unref(PEOPLE_COLLECTION).individual)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["variant"]),
                  _createVNode(_component_AppLoadingButton, {
                    class: "btn",
                    variant: _unref(ColorVariants).secondary,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (handleSelectPeopleCollection(_unref(PEOPLE_COLLECTION).group)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18,
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["variant"])
                ]))
        ])
      ]),
      _: 1
    }, 8, ["visible", "btns", "title"]),
    (question.value)
      ? (_openBlock(), _createBlock(_component_AppDialog, {
          key: 0,
          visible: _unref(dialog).quiz,
          "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_unref(dialog).quiz) = $event)),
          title: question.value.text,
          btns:  question.value.kind === 'input' ? [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => handleCancelQuiz() },
        { text: '적용하기', style: _unref(ColorVariants).primary, disabled: !quizInput.value, click: () => handleAnswerQuiz() },
      ] : [],
          class: "dialog-coca-cola"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              (question.value.kind === 'choice')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(question.value.survey_options, (item, index) => {
                    return (_openBlock(), _createBlock(_component_AppLoadingButton, {
                      key: index,
                      class: "choice-btn",
                      pill: "",
                      variant: _unref(ColorVariants).info,
                      onClick: ($event: any) => (handleAnswerQuiz(item))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(OPTION_NAMES[index]) + "." + _toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant", "onClick"]))
                  }), 128))
                : _createCommentVNode("", true),
              (question.value.kind === 'input')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", null, _toDisplayString(question.value.tips), 1),
                    _createVNode(_component_b_form_input, {
                      modelValue: quizInput.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((quizInput).value = $event)),
                      modelModifiers: { trim: true },
                      class: "input",
                      required: "",
                      type: "text"
                    }, null, 8, ["modelValue"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["visible", "title", "btns"]))
      : _createCommentVNode("", true)
  ]))
}
}

})